import { css } from "@emotion/css";
import { space } from "@octopusdeploy/design-system-tokens";
import { useAggregateAPIOperationStatus, useMutation } from "@octopusdeploy/octopus-react-client";
import type { CreatePolicyResource, GitRef } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import { useState } from "react";
import PolicySlugEditor from "~/areas/platformHub/policies/PolicySlugEditor";
import SaveDialogLayout from "~/components/DialogLayout/SaveDialogLayout";
import { useSpaceAwareNavigation } from "~/components/Navigation/SpaceAwareNavigation/useSpaceAwareNavigation";
import { Text } from "~/components/form/index";
export interface CreatePolicyDialogProps {
    gitRef: GitRef;
}
export function CreatePolicyDialog({ gitRef }: CreatePolicyDialogProps) {
    const [name, setName] = useState<string>("");
    const [slug, setSlug] = useState("");
    const navigation = useSpaceAwareNavigation();
    const defaultModel: CreatePolicyResource = {
        Name: "",
        GitRef: gitRef,
        Slug: "",
        Description: null,
        ScopeRego: `package ${slug}\n\ndefault evaluate := true`,
        ConditionsRego: `package ${slug}\n\ndefault result := {"allowed": true}`,
        ViolationReason: null,
        ViolationAction: "block",
    };
    const { execute: createPolicy } = useMutation({
        name: "Create Policy",
        action: async (repository) => await repository.Policy.create({ ...defaultModel, Name: name, Slug: slug, ChangeDescription: `Create policy '${name}'` }),
        afterComplete: async (_, output) => {
            navigation.navigate(links.editPolicyPage.generateUrl({ slug: output.Slug }, { gitRef: output.GitRef }));
        },
    });
    const { isInProgress, errors } = useAggregateAPIOperationStatus();
    const hasMissingValues = !name || !slug;
    return (<SaveDialogLayout title={"Create Policy"} busy={isInProgress} errors={errors} onSaveClick={async () => {
            await createPolicy();
            return true;
        }} saveButtonLabel={"Create"} busyButtonLabel={"Creating..."} saveButtonDisabled={hasMissingValues}>
            <div className={styles.content}>
                <Text value={name} label="Name" onChange={(value) => {
            setName(value);
        }}/>
                <PolicySlugEditor label={"Slug"} value={slug} onChange={setSlug} policyName={name}/>
            </div>
        </SaveDialogLayout>);
}
const styles = {
    content: css({
        display: "flex",
        flexDirection: "column",
        gap: space[8],
    }),
};
